import { Injectable, Inject } from '@angular/core';
import { URLSearchParams, Headers } from '@angular/http';
import { Observable } from 'rxjs';

import { Mappings } from '../../shared/mapping';
import { AppConfig } from '../../models/core/app-config';
import { ApiService } from './api.service';
import { CookieService } from './cookie';
import { CacheService } from './cache.service';
import { NodeLoggerService } from './node-logger.service';

@Injectable()
export class ApplicationService {
  static ACCESS_TOKEN_KEY: string = 'accessToken';
  static APPLICATION_CONFIG: string = 'ApplicationConfig';

  public get accessToken(): string {
    return this.cookie.get(ApplicationService.ACCESS_TOKEN_KEY);
  }

  public config: AppConfig;

  constructor(private api: ApiService,
              @Inject('isNode') private isNode: boolean,
              @Inject('CookieService') private cookie: CookieService,
              private cache: CacheService,
              private nodeLogger: NodeLoggerService) {
    this.getConfig();
  }

  public getToken(): Observable<any> {
    if (!this.isNode /*|| 'string' === typeof this.accessToken*/) {
      return;
    }

    var startDate = new Date();

    let params = this.getCredentialsParams();
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.api
      .post(`${this.config.apiUrl}${Mappings.Web_Api_Get_Token_Url}`, params, {headers})
      .do(({access_token}) => {
        if (access_token) {
          this.cache.set('__ACCESS_TOKEN__', access_token);
          this.cookie.put(ApplicationService.ACCESS_TOKEN_KEY, access_token);
        }
      });
  }

  private getCredentialsParams() {
    let config = this.getConfig();
    let params = new URLSearchParams();
    params.set('grant_type', 'password');
    params.set('username', config.credentials.username);
    params.set('password', config.credentials.password);
    return params;
  }

  public getConfig(): any {
    if (this.config) {
      return this.config;
    }
    if (this.isNode) {
      const fs = require('fs');
      this.config = JSON.parse(fs.readFileSync('src/assets/config.json', 'utf8'));
      this.setConfigToCache();
    } else {
      this.config = this.cache.get(ApplicationService.APPLICATION_CONFIG);
    }
    return this.config;
  }

  private setConfigToCache() {
    let privateKeys = ['credentials'];
    let configForCache = {};
    for (let key in this.config) if (this.config.hasOwnProperty(key)) {
      if (privateKeys.indexOf(key) === -1) {
        configForCache[key] = this.config[key];
      }
    }
    this.cache.set(ApplicationService.APPLICATION_CONFIG, configForCache);
  }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/application.service.ts